import { Component, HostListener,AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewComponent } from '../../components/reviewCard/review.component';
import Swiper from 'swiper/bundle';


@Component({
  selector: 'app-opinions',
  standalone: true,
  imports: [CommonModule, ReviewComponent],
  templateUrl: './opinions.component.html',
  styleUrls: ['./opinions.component.scss']
})
export class OpinionsComponent implements AfterViewInit {
  // Datos de ejemplo para las reseñas

  swiper!: Swiper;
  ngAfterViewInit(): void {
    this.swiper = new Swiper('.swiper-container', {
      loop: true,
      autoplay: true,
      
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween:20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    });
  }
  

  data: any[] = [
    {
      id: 1,
      name: 'Anyeli Jimenez',
      img : 'https://lh3.googleusercontent.com/a/ACg8ocLfWacHqei1HVBmcwF9Z4zVCGlyQJ5Leu1PJCVljhcM5HGB6A=w36-h36-p-rp-mo-br100',
      text: 'Muy buenas tardes.Les doy las gracias  a este hermoso servicio.Muchisimas bendiciones para todos los trabajadores de este medio de comunicación.🙏🏼 Gracias Continúen asi.…',
      rating: 5
    },
    {
      id: 2,
      name: 'Blanca Carillo',
      img : 'https://lh3.googleusercontent.com/a/ACg8ocLPYhlV8Y6XPnudR0ijp9b_9wuFF4nuXQTaC7SMxIF-P7aY9w=w36-h36-p-rp-mo-br100',

      text: 'Excelente y eficaz muy conforme con la atención, siempre lo importante es que nos solucionen sin tantos obstáculos. Agradecida, muchas gracias',
      rating: 5
    },
    {
      id: 3,
      name: 'Yulianny Yura',
      img:'https://lh3.googleusercontent.com/a/ACg8ocIWoq8ROBcolrRbAwVkuPNQkQMDt9E8Z0C38Pdx6dzF63DTmg=w36-h36-p-rp-mo-br100',
      text: 'Muy atento al Servicio ❤️✨ El internet todo excelente',
      rating: 5
    },
    {
      id: 4,
      name: 'Victoria Marin',
      img:'https://lh3.googleusercontent.com/a-/ALV-UjU8gBMaR_PRToGB-CON-DTaVriGwcY27JFev4LkvznAd2-Hmrs=w36-h36-p-rp-mo-br100',
      text: 'Excelente experiencia y muy buen servicio. Lo super recomiendo👌…',
      rating: 5
    },
    {
      id: 5,
      name: 'Yaili Gamboa',
      text:'Excelente atención y un excelente servicio de atención',
      img: 'https://lh3.googleusercontent.com/a/ACg8ocLKE6-tLQEI2XNauVIZVv-dvGUiN8q_Anx4uc-JnzVj4JmFiQ=w36-h36-p-rp-mo-br100',
      rating: 5
    },
    {
      id: 6,
      name: 'junior murillo malave',
      img:'https://lh3.googleusercontent.com/a-/ALV-UjUQi8v6vGhU_svR1rFnipmZLMLMhocC2qNjxtcWH5Yv-X3sBvGr=w36-h36-p-rp-mo-br100',
      text: 'Exelente nos sirve para comunicarnos en nuestras áreas de trabajo si se presenta alguna emergencia',
      rating: 4
    }
  ];



  
  
 
}